export const POSTIDENT_RETURN_RESULTS = ['success', 'declined', 'reviewPending'];
export var PostIdentCaseStatus;
(function (PostIdentCaseStatus) {
    PostIdentCaseStatus["CREATED"] = "CREATED";
    PostIdentCaseStatus["IN_PROGRESS"] = "IN_PROGRESS";
    PostIdentCaseStatus["COMPLETED"] = "COMPLETED";
    PostIdentCaseStatus["FAILED"] = "FAILED";
    PostIdentCaseStatus["CANCELLED"] = "CANCELLED";
})(PostIdentCaseStatus || (PostIdentCaseStatus = {}));
export var PostIdentAPICaseStatus;
(function (PostIdentAPICaseStatus) {
    PostIdentAPICaseStatus["IN_PROGRESS"] = "in progress";
    PostIdentAPICaseStatus["CLOSED"] = "closed";
    PostIdentAPICaseStatus["NEW"] = "new";
})(PostIdentAPICaseStatus || (PostIdentAPICaseStatus = {}));
export var PostIdentAPIIdentificationStatus;
(function (PostIdentAPIIdentificationStatus) {
    PostIdentAPIIdentificationStatus["STARTED"] = "started";
    PostIdentAPIIdentificationStatus["REVIEW_PENDING"] = "review pending";
    PostIdentAPIIdentificationStatus["SUCCESS"] = "success";
    PostIdentAPIIdentificationStatus["DECLINED"] = "declined";
    PostIdentAPIIdentificationStatus["INCOMPLETE"] = "incomplete";
    PostIdentAPIIdentificationStatus["COUPON_REQUESTED"] = "coupon requested";
    PostIdentAPIIdentificationStatus["CANCELLED"] = "cancelled";
})(PostIdentAPIIdentificationStatus || (PostIdentAPIIdentificationStatus = {}));
export var PostIdentIdentificationMethod;
(function (PostIdentIdentificationMethod) {
    PostIdentIdentificationMethod["VIDEO"] = "video";
    PostIdentIdentificationMethod["PHOTO"] = "photo";
    PostIdentIdentificationMethod["EID"] = "eid";
    PostIdentIdentificationMethod["AUTOID"] = "autoid";
    PostIdentIdentificationMethod["BASIC"] = "basic";
})(PostIdentIdentificationMethod || (PostIdentIdentificationMethod = {}));
//# sourceMappingURL=postident.types.js.map